@for (item of jointOwnershipForm.controls; track item; let i = $index) {
  <div [formGroup]="item">
    <div class="row">
      @if (reference$ | async; as reference) {
        <div class="col col-xs-12 col-sm-12 col-md-3">
          <pr-input-column label="Nom" [derrors]="derrors">
            <input formControlName="lastname" type="text" />
          </pr-input-column>
        </div>
        <div class="col col-xs-12 col-sm-12 col-md-3">
          <pr-input-column label="Prénom" [derrors]="derrors">
            <input formControlName="firstname" type="text" />
          </pr-input-column>
        </div>
        <div class="col col-xs-12 col-sm-12 col-md-3">
          <div style="width: calc(100% - 33px)">
            <pr-input-date
              label="Date de naissance"
              formControlName="birthdate"
              [derrors]="derrors"
              [isDefault]="false"
            ></pr-input-date>
          </div>
        </div>
        <div class="col col-xs-12 col-sm-12 col-md-3">
          <pr-input-column label="Ville de naissance" [derrors]="derrors">
            <input formControlName="birthLocation" type="text" />
          </pr-input-column>
        </div>
        <div class="col col-xs-12 col-sm-12 col-md-3">
          <pr-input-column label="Code postal de naissance" [derrors]="derrors">
            <input formControlName="birthZipCode" type="text" />
          </pr-input-column>
        </div>
        <div class="col col-xs-12 col-sm-12 col-md-3">
          <pr-input-column label="Téléphone" [derrors]="derrors">
            <input formControlName="phone" type="phone" />
          </pr-input-column>
        </div>
        <div class="col col-xs-12 col-sm-12 col-md-3">
          <pr-input-column label="Email" [derrors]="derrors">
            <input formControlName="email" type="email" />
          </pr-input-column>
        </div>
        <div class="col col-xs-12 col-sm-12 col-md-3">
          <pr-input-column label="Situation famliliale" [derrors]="derrors">
            <mat-select #select formControlName="maritalSituation">
              @for (situation of maritalSituations; track situation) {
                <mat-option [value]="situation.id">
                  {{ situation.value }}
                </mat-option>
              }
            </mat-select>
          </pr-input-column>
        </div>
        <div class="col col-xs-12 col-sm-12 col-md-12">
          <pr-input-column
            label="Adresse de résidence principale"
            [derrors]="derrors"
          >
            <input formControlName="postalAddress" type="text" />
          </pr-input-column>
        </div>
        <div class="col col-xs-12 col-sm-12 col-md-5">
          <pr-input-column label="Nationalité" [derrors]="derrors">
            <mat-select #select formControlName="nationality">
              @for (country of reference.countries; track country) {
                <mat-option [value]="country.id">
                  {{ country.value }}
                </mat-option>
              }
            </mat-select>
          </pr-input-column>
        </div>
        <div class="col col-xs-12 col-sm-12 col-md-7">
          <pr-input-column label="Caisse d'affiliation" [derrors]="derrors">
            <mat-select #select formControlName="enrollmentOffice">
              @for (
                enrollmentOffice of enrollmentOffices;
                track enrollmentOffice
              ) {
                <mat-option [value]="enrollmentOffice.id">
                  {{ enrollmentOffice.value }}
                </mat-option>
              }
            </mat-select>
          </pr-input-column>
        </div>
        <div class="col col-xs-12 col-sm-12 col-md-6">
          <pr-input-column label="Numéro fiscal" [derrors]="derrors">
            <input formControlName="fiscalNumber" type="text" />
          </pr-input-column>
        </div>
        <div class="col col-xs-12 col-sm-12 col-md-6">
          <pr-input-column
            label="Numéro de sécurité social"
            [derrors]="derrors"
          >
            <input
              formControlName="socialSecurityNumber"
              type="text"
              prSocialSecurityNumber
            />
          </pr-input-column>
        </div>
        <div class="col col-md-3 align-self-center" style="margin-top: 2rem">
          @if (jointOwnershipForm.length > 1) {
            <pr-button-confirm
              class="confirm"
              display="danger"
              clazz="pr-toolbar-button last"
              icon="delete_outline"
              title="Suppression"
              comment="Toute suppression est définitve, les données seront perdues."
              labelConfirm="Supprimer"
              labelCancel="Annuler"
              (onConfirm)="deleteFields(i)"
            >
              Êtes-vous sûr(e) de vouloir supprimer
            </pr-button-confirm>
          }
        </div>
      }
    </div>
  </div>
}

<div class="row">
  <div class="col col-md-4">
    <pr-button-add
      type="button"
      display="neutral"
      (click)="addFields()"
      label="Ajouter un indivisaire"
      rightIcon="+"
    >
    </pr-button-add>
  </div>
</div>
